import { useQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { GetBalanceStatisticsResponse, RequestParams } from 'api';

export const CURRENT_USER_BALANCE_QUERY_KEY = 'vestra/current-user-balance';

export const useBalanceStatisticsQuery = (
  register_id: string,
  params?: { disabled?: boolean; request?: RequestParams },
) => {
  return useQuery<GetBalanceStatisticsResponse>({
    queryKey: [CURRENT_USER_BALANCE_QUERY_KEY, register_id],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response = await api.v1.getBalanceStatisticsV1SrBalanceStatisticsGet(params?.request);
      return response.data;
    },
    retry: 2,
    enabled: !params?.disabled,
  });
};
